import { Theme, alpha } from '@mui/material';

export default {
    requestErrorPageContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    requestErrorContainer: {
        display: 'flex',

        '&.request-error-message--view-inline': {
            flexDirection: 'row',
            '& .request-error-message__icon-holder': {
                marginRight: '12px',
            },
        },

        '&.request-error-message--view-page': {
            flexDirection: 'column',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            '& .request-error-message__icon-holder': {
                marginBottom: '12px',
            },
        },
    },
    requestErrorIconHolder: {
        display: 'inline-flex',
        fontSize: '32px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.4),
        '& .svg-icon-mi': {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            flexShrink: 0,
            fill: 'currentColor',
            fontSize: 'inherit',
        },
    },
    requestErrorMessageHolder: {},
};
